import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const planExportPageRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps',
	path: '/jira/plans/:planId/scenarios/:scenarioId/export',
};
